export class WaterfallItem {
    public seqColor: string;
    public seqTop: number;
    public seqHeight: number;
    public absColor: string;
    public absTop: number;
    public absHeight: number;

    public maxHeight() {
        return this.seqHeight > this.absHeight ? this.seqHeight : this.absHeight;
    }
}